import { atom } from 'recoil';

const collectionErrorAtom = atom({
  key: 'collectionError',
  default: { Name: '', Subname: '', Description: '' },
});

export { collectionErrorAtom };
